import { AnyAction } from 'redux';
import { Session } from 'sip.js';
// @ts-ignore
import Timer from 'easytimer.js';
import * as actionTypes from '../actions/actionTypes';

export interface IAppSession {
  id?: string;
  from: string;
  numberFrom: string;
  contactId: string;
  contactName: string;
  session: Session;
  mute: boolean;
  timerRinging: Timer;
  timerDuring: Timer;
  hold: boolean;
  invite: boolean;
  answered: boolean;
  finished: boolean;
  transfer: boolean;
  dialpad: boolean;
  dtmf: string | boolean;
  dtmfValue: string;
  waitingToMergeConf: boolean;
  waitingTransfer: string | boolean | null;
  readyToMergeCall: boolean;
  status: string;
  callConference: boolean;
  callActions: {
    transfer: boolean;
    conference: boolean;
    announcement: boolean;
    tags: boolean;
    notes: boolean;
  };
}

export interface EnumSessionItems extends Array<IAppSession> {}

export enum VideoState {
  Initial = 'initial',
  Establishing = 'establishing',
  Established = 'established',
  Completed = 'completed',
}
export interface IVideoCallCurrent {
  callId: string;
  from: string;
  fromName: string;
  to: string;
  toName: string;
  state: VideoState;
  isInviter: boolean;
  roomUrl: string | null;
}

interface ICallCurrentState {
  loading: boolean;
  data: EnumSessionItems;
  session: Session | null;
  video: IVideoCallCurrent | null;
  isVideoCallActive: boolean;
}

const initialState: ICallCurrentState = {
  loading: false,
  data: [],
  session: null,
  video: null,
  isVideoCallActive: false,
};

const callCurrent = (
  state: ICallCurrentState = initialState,
  action: AnyAction
): ICallCurrentState => {
  switch (action.type) {
    case actionTypes.UPDATE_CALLS_CURRENT_LOADING:
      return {
        ...state,
        loading: action.payload.loading,
      };
    case actionTypes.UPDATE_CALLS_CURRENT_FINISH:
      return {
        ...state,
        data: action.payload.data,
      };
    case actionTypes.UPDATE_CALLS_CURRENT_ACTIVE:
      return {
        ...state,
        session: action.payload.session,
      };
    case actionTypes.VIDEO_NEW_CALL:
      return {
        ...state,
        video: action.payload.data,
      };
    case actionTypes.UPDATE_VIDEO_CALL:
      return {
        ...state,
        video: action.payload.data,
      };
    case actionTypes.VIDEO_CALL_ACTIVE:
      return {
        ...state,
        isVideoCallActive: action.payload.data,
      };
    case actionTypes.RESET_CALLS_CURRENT:
      return initialState;
    default:
      return {
        ...state,
      };
  }
};

export default callCurrent;
